import { render, staticRenderFns } from "./WatchTogetherVolumeSlider.vue?vue&type=template&id=52f93b2c&scoped=true&"
import script from "./WatchTogetherVolumeSlider.vue?vue&type=script&lang=js&"
export * from "./WatchTogetherVolumeSlider.vue?vue&type=script&lang=js&"
import style0 from "./WatchTogetherVolumeSlider.vue?vue&type=style&index=0&id=52f93b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f93b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f93b2c')) {
      api.createRecord('52f93b2c', component.options)
    } else {
      api.reload('52f93b2c', component.options)
    }
    module.hot.accept("./WatchTogetherVolumeSlider.vue?vue&type=template&id=52f93b2c&scoped=true&", function () {
      api.rerender('52f93b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/watchTogether/ongoing/WatchTogetherVolumeSlider.vue"
export default component.exports